import EmployeeJobType from 'src/models/employee-job-type/EmployeeJobType'
import Model, { ID, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'

export const SCHEDULES = {
  IMMEDIATE: 'immediate',
  DAILY: 'daily',
  WEEKLY: 'weekly'
}
SCHEDULES.ALL = _.values(SCHEDULES)
Object.freeze(SCHEDULES)

export const SCHEDULE_CONDITIONS = {
  TIME_OF_DAY: 'time-of-day',
  DAY_OF_WEEK: 'day-of-week',
  DELAY_DISTRIBUTION: 'delay-distribution'
}
SCHEDULE_CONDITIONS.ALL = _.values(SCHEDULE_CONDITIONS)
SCHEDULE_CONDITIONS[SCHEDULES.IMMEDIATE] = [SCHEDULE_CONDITIONS.DELAY_DISTRIBUTION]
SCHEDULE_CONDITIONS[SCHEDULES.DAILY] = _.without(SCHEDULE_CONDITIONS.ALL, SCHEDULE_CONDITIONS.DAY_OF_WEEK)
SCHEDULE_CONDITIONS[SCHEDULES.WEEKLY] = SCHEDULE_CONDITIONS.ALL
Object.freeze(SCHEDULE_CONDITIONS)

export const SCHEDULE_CONDITIONS_REQUIREMENTS = {
  // HOUR_OF_DAY
  TIME_OF_DAY: 'timeOfDay',
  // DAY_OF_WEEK
  DAY_OF_WEEK: 'dayOfWeek',
  // DELAY_DISTRIBUTION
  DELAY_DISTRIBUTION_HOURS: 'delayDistributionHours'
}
SCHEDULE_CONDITIONS_REQUIREMENTS.ALL = _.values(SCHEDULE_CONDITIONS_REQUIREMENTS)
Object.freeze(SCHEDULE_CONDITIONS_REQUIREMENTS)

export const STRATEGIES = {
  CLOCKED_IN: 'clocked-in',
  PROPORTIONAL: 'proportional'
}
STRATEGIES.ALL = _.values(STRATEGIES)
Object.freeze(STRATEGIES)

export const STRATEGY_CONDITIONS = {
  REQUIRED_HOURS: 'required-hours'
}
STRATEGY_CONDITIONS.ALL = _.values(STRATEGY_CONDITIONS)
STRATEGY_CONDITIONS[STRATEGIES.CLOCKED_IN] = []
STRATEGY_CONDITIONS[STRATEGIES.PROPORTIONAL] = STRATEGY_CONDITIONS.ALL
Object.freeze(STRATEGY_CONDITIONS)

export const STRATEGY_CONDITIONS_REQUIREMENTS = {
  // REQUIRED_HOURS
  REQUIRED_HOURS_MINIMUM: 'requiredHoursMinimum'
}
STRATEGY_CONDITIONS_REQUIREMENTS.ALL = _.values(STRATEGY_CONDITIONS_REQUIREMENTS)
Object.freeze(STRATEGY_CONDITIONS_REQUIREMENTS)

export default class TipPoolType extends Model {
  static name = 'TipPoolType'

  static level = MODEL_LEVEL.SITE

  static deletable = true
  static duplicatable = true
  static paginate = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Tipping]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String,
        sortable: true
      },
      employeeJobTypes: {
        type: [EmployeeJobType],
        default: () => ([]),
        reference: true
      },
      distributionStrategy: {
        type: String,
        default: STRATEGIES.CLOCKED_IN
      },
      distributionStrategyConditions: {
        type: JsonObject,
        mergeDefault: true,
        default: () => _(STRATEGY_CONDITIONS.ALL).keyBy().mapValues(() => false).value()
      },
      distributionStrategyConditionsRequirements: {
        type: JsonObject,
        mergeDefault: true,
        default: () => ({})
      },
      distributionSchedule: {
        type: String,
        default: SCHEDULES.IMMEDIATE
      },
      distributionScheduleConditions: {
        type: JsonObject,
        mergeDefault: true,
        default: () => _(SCHEDULE_CONDITIONS.ALL).keyBy().mapValues(() => false).value()
      },
      distributionScheduleConditionsRequirements: {
        type: JsonObject,
        mergeDefault: true,
        default: () => ({})
      }
    }
  }
}
